import { FireCMSTranslations } from "../types/translations";

export const it: FireCMSTranslations = {
    // ─── Form actions ────────────────────────────────────────────
    save: "Salva",
    create: "Crea",
    create_copy: "Crea copia",
    save_and_close: "Salva e chiudi",
    create_copy_and_close: "Crea copia e chiudi",
    create_and_close: "Crea e chiudi",
    discard: "Scarta",
    clear: "Cancella",
    cancel: "Annulla",

    // ─── Entity actions ──────────────────────────────────────────
    edit: "Modifica",
    copy: "Copia",
    delete: "Elimina",

    // ─── Delete dialog ───────────────────────────────────────────
    delete_confirmation_title: "Eliminare?",
    delete_confirmation_body: "Questo eliminerà l'entità. Sei sicuro?",
    delete_multiple_confirmation_body: "Questo eliminerà le entità selezionate. Sei sicuro?",

    // ─── Unsaved-changes dialog ───────────────────────────────────
    unsaved_changes_title: "Modifiche non salvate",
    unsaved_changes_body: "Hai modifiche non salvate. Vuoi scartarle?",
    discard_changes: "Scarta le modifiche",
    keep_editing: "Continua a modificare",

    // ─── Collection table / toolbar ──────────────────────────────
    search: "Cerca",
    find_by_id: "Cerca per ID",
    find_entity_by_id: "Cerca entità per ID",
    filter: "Filtra",
    filters: "Filtri",
    clear_filter: "Cancella filtro",
    clear_filter_sort: "Cancella filtro/ordinamento",
    clear_sort: "Cancella ordinamento",
    no_items: "Nessun elemento",
    no_entries_found: "Nessuna voce trovata",
    all_entries_loaded: "Tutte le {{count}} voci caricate",
    create_your_first_entry: "Crea la tua prima voce",
    no_results_filter_sort: "Nessun risultato con il filtro/ordinamento applicato",
    add: "Aggiungi",
    remove: "Rimuovi",
    multiple_entities: "Entità multiple",
    unsaved_changes: "Hai modifiche non salvate in {{collectionName}}.",
    so_empty: "Così vuoto...",
    no_results: "Nessun risultato con il filtro/ordinamento applicato",
    refresh_data: "Aggiorna i dati",
    dark_mode: "Scuro",
    light_mode: "Chiaro",
    system_mode: "Sistema",
    ok: "Ok",
    save_collection_config: "Salva struttura della collezione",
    search_for_more_icons: "Cerca altre icone…",
    ai_modified: "Modificato dall'IA",
    size_label: "Dimensioni",
    group_by: "Raggruppa per",
    initialize_kanban_order: "Inizializza ordine Kanban",
    copy_id: "Copia ID",
    add_specific: "Aggiungi {{name}}",
    select_specific: "Seleziona {{name}}",
    select_from: "Seleziona da {{name}}",
    done: "Fatto",
    log_out: "Esci",
    license_needed: "Licenza necessaria",
    license_description: "Hai bisogno di una licenza valida per utilizzare FireCMS PRO. Contattaci a {{email}} per maggiori informazioni.",
    column_cannot_be_edited: "Questa colonna non può essere modificata direttamente",
    close: "Chiudi",
    unsaved_local_changes: "Modifiche locali non salvate",
    unsaved_local_changes_description: "Questo documento è stato modificato localmente e ha modifiche non salvate. Queste modifiche locali andranno perse se non le applichi.",
    preview_changes: "Anteprima modifiche",
    apply_changes: "Applica modifiche",
    discard_local_changes: "Scarta modifiche locali",
    preview_local_changes: "Anteprima modifiche locali",
    preview_local_changes_description: "Queste sono le modifiche locali che verranno applicate al modulo.",
    type: "Tipo",
    string: "stringa",
    number: "numero",
    boolean: "booleano",
    date: "data",
    map: "mappa",
    array: "array",
    arrays_of_arrays_not_supported: "Array di array non sono supportati.",
    data_type_not_supported: "Tipo di dati {{dataType}} non ancora supportato",
    passkey_error_unsupported: "Il tuo dispositivo o browser non supporta le passkey.",

    admin: "Admin",
    home: "Home",
    this_form_has_errors: "Questo modulo contiene errori",
    error_loading_navigation: "Errore durante il caricamento della navigazione",
    error_loading_auth: "Errore durante il caricamento dell'autenticazione",
    this_form_has_been_modified: "Questo modulo è stato modificato",
    current_form_in_sync: "Il modulo corrente è sincronizzato con il database",
    open_in_console: "Apri nella console",
    collection_does_not_exist: "La collezione specificata non esiste. Controlla la console",
    unexpected_value: "Valore inaspettato",
    unexpected_value_click_to_edit: "Valore inaspettato. Fai clic per modificare",
    unexpected_reference_value: "Valore di riferimento inaspettato. Fai clic per modificare",
    copy_url_to_clipboard: "Copia url negli appunti",
    open_image_in_new_tab: "Apri immagine in una nuova scheda",
    reference_not_set: "Riferimento non impostato",
    reference_does_not_exist: "Il riferimento non esiste",
    entity_not_found: "Entità non trovata",
    file_not_found: "File non trovato",
    unsaved_changes_in_entity: "Hai modifiche non salvate in questa entità.",
    delete_this_role: "Elimina questo ruolo",
    no_roles_yet: "Non hai ancora ruoli.",
    create_default_roles: "Crea ruoli predefiniti",
    delete_role_confirmation: "Sei sicuro di voler eliminare questo ruolo?",
    delete_this_user: "Elimina questo utente",
    no_users_yet: "Non ci sono ancora utenti",
    add_logged_user_as_admin: "Aggiungi l'utente registrato come amministratore",
    add_current_user_as_admin: "Aggiungi l'utente corrente come amministratore",
    create_default_roles_and_add_admin: "Crea i ruoli predefiniti e aggiungi l'utente corrente come amministratore",
    delete_user_confirmation: "Sei sicuro di voler eliminare questo utente?",
    create_your_users_and_roles: "Crea i tuoi utenti e ruoli",
    no_users_or_roles_defined: "Non hai definito né utenti né ruoli. Puoi creare ruoli predefiniti e aggiungere l'utente corrente come amministratore.",
    save_before_changing_schema: "Devi salvare il documento prima di modificare lo schema",
    edit_schema_for_this_form: "Modifica lo schema per questo modulo",
    no_permissions_to_edit_collection: "Non hai i permessi per modificare questa collezione",
    browser_does_not_support_audio: "Il tuo browser non supporta l'elemento audio.",
    user_not_found: "Utente non trovato: {{value}}",

    // ─── Collection view actions ──────────────────────────────────
    delete_selected: "Elimina selezionato",
    cannot_delete_selected: "Hai selezionato almeno un'entità che non puoi eliminare",

    // ─── Array / field containers ─────────────────────────────────
    add_entry: "Aggiungi",
    add_on_top: "Aggiungi in alto",
    add_below: "Aggiungi in basso",
    add_to_field: "Aggiungi a {{fieldName}}",
    value: "Valore",
    key: "Chiave",
    drag_drop_multiple: "Trascina qui alcuni file oppure fai clic per selezionarli. Trascina per riordinare.",
    drag_drop_single: "Trascina qui un file oppure fai clic per selezionarne uno",

    // ─── Navigation / scaffold ────────────────────────────────────
    open_menu: "Apri menù",
    close_drawer: "Chiudi cassetto",
    navigation_drawer: "Cassetto di navigazione",

    // ─── Error states ─────────────────────────────────────────────
    error: "Errore",
    error_uploading_file: "Errore durante il caricamento del file",
    error_deleting: "Errore durante l'eliminazione",
    error_before_delete: "Errore prima dell'eliminazione",
    error_updating_asset: "Errore durante l'aggiornamento dell'asset",
    error_deleting_asset: "Errore durante l'eliminazione dell'asset",
    error_firestore_index: "Per questa query è richiesto un indice Firestore.",
    create_index: "Crea indice",
    value_is_not_reference: "Il valore non è un riferimento.",
    click_to_edit: "Fai clic per modificare",
    data_is_not_array_of_references: "I dati non sono un array di riferimenti",

    // ─── Misc ─────────────────────────────────────────────────────
    loading: "Caricamento in corso",
    local_changes_applied: "Modifiche locali applicate al modulo",
    local_changes_discarded: "Modifiche locali scartate",
    are_you_sure_leave: "Sei sicuro di voler uscire da questa pagina?",
    see_console_details: "Vedi la console per maggiori dettagli.",
    drop_here_create_group: "Rilascia qui per creare un nuovo gruppo",
    filter_for_null_values: "Filtra per valori nulli",
    value_updated_elsewhere: "Questo valore è stato aggiornato altrove",
    add_property: "Aggiungi proprietà",
    edit_name: "Modifica {{name}}",
    this_entity_not_exist: "Questa entità non esiste nel database",
    internal_error: "ERRORE interno",

    // ─── Rename group dialog ──────────────────────────────────────
    rename_group: "Rinomina gruppo",
    group_name_label: "Nome gruppo",
    group_name_empty_error: "Il nome del gruppo non può essere vuoto.",
    group_name_exists_error: "Questo nome del gruppo esiste già.",

    // ─── Search ───────────────────────────────────────────────────
    search_collections: "Cerca collezioni",

    // ─── Navigation groups ────────────────────────────────────────
    views_group: "Viste",

    // ─── Entity Edit View ─────────────────────────────────────────
    youd_need_to_save_before_additional_collections: "Devi salvare la tua entità prima di poter aggiungere altre collezioni",

    // ─── Not Found Page ───────────────────────────────────────────
    page_not_found: "Pagina non trovata",
    page_not_found_body: "Questa pagina non esiste o potresti non avere i permessi per accedervi",
    back_to_home: "Torna alla home",

    // ─── Collection Editor ─────────────────────────────────────────
    default_collection_view: "Vista collezione predefinita",
    table_view: "Tabella",
    cards_view: "Schede (card)",
    kanban_view: "Kanban",
    choose_how_entities_displayed_default: "Scegli come debbano essere visualizzate le entità di default",

    document_view: "Vista documento",
    side_panel: "Pannello laterale",
    full_screen: "Schermo intero",
    should_documents_opened_full_screen: "I documenti dovrebbero essere aperti a schermo intero o in una finestra di dialogo laterale integrata",

    select_custom_view: "Seleziona vista personalizzata",
    no_custom_views_defined: "Nessuna vista personalizzata definita. Definisci le viste personalizzate nelle impostazioni di personalizzazione prima di utilizzare questa finestra.",

    select_custom_action: "Seleziona azione personalizzata",
    no_custom_actions_defined: "Nessuna azione personalizzata definita. Definisci le azioni personalizzate nelle impostazioni di personalizzazione prima di utilizzare questa finestra.",

    no_collections_found: "Nessuna collezione trovata",
    start_building_collections: "Inizia facilmente a costruire collezioni in FireCMS. Mapale comodamente ai dati del tuo database esistente, importali da file o usa i nostri modelli.",
    create_first_collection: "Crea la tua prima collezione",
    define_collections_programmatically: "Puoi anche definire le collezioni a livello di codice.",
    edit_collection: "Modifica collezione",
    no_permissions_edit_collection: "Non disponi dei permessi per modificare questa collezione",
    no_permissions_create_collection: "Non disponi dei permessi per creare collezioni",
    create_collection: "Crea collezione",
    update_collection: "Aggiorna collezione",

    new_collection: "Nuova collezione",
    add_new_collection: "Aggiungi nuova collezione",
    collection_with_name: "Collezione {{name}}",
    change_icon: "Cambia icona",
    is_subcollection_of: "Questa è una sottocollezione di",
    name: "Nome",
    collection_name_description: "Il nome di questa collezione, solitamente un nome al plurale (es. Prodotti)",
    path: "Percorso",
    relative_path_to_parent: "Percorso relativo al genitore (non è necessario includere il percorso genitore)",
    path_in_database: "Il percorso in cui questa collezione è archiviata nel database",
    singular_name: "Nome singolare",
    singular_name_description: "Facoltativamente definisci un nome singolare per le tue entità",
    description: "Descrizione",
    description_of_collection: "Descrizione della collezione, puoi utilizzare il markdown",
    collection_id: "ID della collezione",
    collection_id_description: "Questo ID identifica in modo univoco questa collezione. Spesso coincide con il percorso.",
    collection_group: "Gruppo di collezioni",
    collection_group_description: "Un gruppo di collezioni include tutte le collezioni con lo stesso percorso. Ciò consente di interrogare più collezioni simultaneamente.",
    advanced_settings: "Impostazioni avanzate",
    doc_history_global: "Revisioni della cronologia dei documenti abilitate se abilitate a livello globale",
    doc_history_enabled: "Revisioni della cronologia dei documenti ABILITATE",
    doc_history_not_enabled: "Revisioni della cronologia dei documenti NON abilitate",
    doc_history_description: "Se abilitata questa opzione, ogni documento in questa collezione avrà una cronologia delle modifiche per scopi di auditing. I dati vengono salvati in una sottocollezione del documento denominata __history.",
    document_id_generation: "Generazione ID documento",
    code_defined: "Definito dal codice",
    users_must_define_id: "Gli utenti devono definire un ID",
    users_can_define_id: "Gli utenti possono definire un ID, ma non è obbligatorio",
    doc_id_auto_generated: "L'ID del documento viene generato automaticamente",
    config_doc_id_generation: "Configura il modo in cui vengono generati gli ID dei documenti per le nuove entità.",
    enable_text_search: "Abilita la ricerca testuale in questa collezione",
    text_search_description: "Attiva la ricerca testuale per questa collezione. Se non è specificato un delegato di ricerca testuale, si utilizzerà la ricerca locale integrata. Si sconsiglia l'uso con collezioni grandi, essendo soggetto a problemi di prestazioni e costi.",
    database_id: "ID del Database",
    default_text: "(predefinito)",

    custom_actions: "Azioni personalizzate",
    more_info: "Ulteriori info",
    define_custom_actions_cli: "Definisci le tue azioni personalizzate ed eseguine l'upload tramite l'interfaccia a riga di comando (CLI).",
    action_defined_in_code: "Questa azione è definita dal codice con la chiave",
    add_custom_entity_action: "Aggiungi azione di entità personalizzata",
    remove_this_action: "Rimuovi questa azione?",
    remove_action_warning: "Questa operazione non eliminerà dati, ma solo l'azione dal CMS",

    subcollections_of: "Sottocollezioni di",
    add_subcollection: "Aggiungi sottocollezione",
    custom_views: "Viste personalizzate",
    define_custom_views_cli: "Definisci le tue viste personalizzate e caricale tramite l'interfaccia a riga di comando (CLI).",
    view_defined_in_code: "Questa vista è definita nel codice dalla chiave",
    add_custom_entity_view: "Aggiungi vista ad entità personalizzata",
    delete_this_subcollection: "Vuoi eliminare questa sottocollezione?",
    remove_collection_warning: "Attenzione: questo rimuoverà solo la collezione configurata nel CMS, senza eliminare i dati effettivi.",
    remove_this_view: "Desideri rimuovere questa vista?",
    remove_view_warning: "Questa azione rimuoverà solo la visualizzazione dal CMS; i dati rimarranno intatti.",

    no_collection_selected: "Nessuna collezione selezionata",
    code_for_collection: "Codice per",
    use_config_define_json: "Utilizza questa configurazione per definire la collezione in formato JSON.",
    customise_collection_code: "Se desideri personalizzare ulteriormente tramite codice la collezione, puoi aggiungere questo frammento di codice nel tuo CMS.",
    copied: "Copiato",

    property_cant_be_edited: "Non è possibile modificare questa proprietà",
    property_not_editable_description: "Potresti non disporre dei permessi per modificarla o potrebbe essere stata impostata nel codice come 'non modificabile' (editable: false).",
    delete_this_property: "Desideri eliminare questa proprietà?",
    delete_property_warning: "Questo non cancellerà i dati associati, modificherà semplicemente la configurazione della collezione.",
    error_must_specify_id: "È d'obbligo specificare un id per questo campo",
    error_id_format: "L'id può contenere solo lettere, numeri e underscore (_) e non deve iniziare con un numero",
    error_id_already_exists: "Esiste già un altro campo utilizzando questo ID",
    error_must_specify_title: "Specifica un titolo obbligatorio per questo campo",
    custom_or_other: "Personalizzato/Altro",
    select_property_widget: "Scegli un widget per la proprietà",
    error_changing_data_type: "Il widget selezionato adotta un formato di dati diverso rispetto a quello iniziale. Questa modifica potrebbe causare errori sui dati già presenti.",
    required: "Richiesto",

    enum_form_dialog: "Finestra di dialogo modulo Enum",
    imported_data_preview: "Anteprima dei dati importati",
    entities_with_same_id_overwritten: "Le entità con lo stesso id verranno sovrascritte",
    collection_editor: "Editor della collezione",
    properties_in_this_group: "Proprietà di questo gruppo",
    data_property_mapping: "Mappatura dei dati alle proprietà",
    property_edit_view: "Vista di modifica delle proprietà",
    all_of_these: "Tutti questi",
    any_of_these: "Alcuni di questi",

    only_admins_edit_roles: "Solo gli amministratori possono modificare i ruoli",
    error_user_not_found: "Utente non trovato",
    role: "Ruolo",
    name_of_this_role: "Nome di questo ruolo",
    id_of_this_role: "ID di questo ruolo",
    create_entities: "Crea entità",
    read_entities: "Leggi entità",
    update_entities: "Aggiorna entità",
    delete_entities: "Elimina entità",
    all_collections: "Tutte le collezioni",
    create_entities_in_collections: "Crea entità nelle collezioni",
    access_all_data_in_every_collection: "Accedi a tutti i dati in ogni collezione",
    update_data_in_any_collection: "Aggiorna i dati in qualsiasi collezione",
    delete_data_in_any_collection: "Elimina i dati in qualsiasi collezione",
    allow_all_permissions_in_this_collections: "Consenti tutti i permessi in queste collezioni",
    all: "Tutto",
    customise_permissions_description: "Puoi personalizzare i permessi che gli utenti associati a questo ruolo possono eseguire nelle entità di ciascuna collezione",
    create_collections: "Crea collezioni",
    yes: "Sì",
    no: "No",
    can_user_create_collections: "L'utente può creare collezioni",
    edit_collections: "Modifica collezioni",
    only_own_collections: "Solo le proprie collezioni",
    own: "Propri",
    can_user_edit_collections: "L'utente può modificare le collezioni",
    delete_collections: "Elimina collezioni",
    can_user_delete_collections: "L'utente può eliminare le collezioni",
    error_saving_role: "Si è verificato un errore durante il salvataggio del ruolo",
    create_role: "Crea ruolo",
    update: "Aggiorna",

    only_admins_change_roles: "Solo gli amministratori possono modificare i ruoli",
    must_be_at_least_one_admin: "Deve esserci almeno un amministratore",
    logged_user_not_found: "Utente connesso non trovato",
    user: "Utente",
    user_id: "ID utente",
    name_of_this_user: "Nome dell'utente",
    email_of_this_user: "Email dell'utente",
    roles: "Ruoli",
    create_user: "Crea utente",

    users: "Utenti",
    add_user: "Aggiungi utente",
    add_role: "Aggiungi ruolo",
    is_admin: "È amministratore",
    default_permissions: "Permessi predefiniti",
    created_on: "Creato il",
    email: "Email",
    id: "ID",
    read: "Lettura",

    column_in_file: "Colonna nel file",
    map_to_property: "Mappa alla proprietà",
    default_values: "Valori predefiniti",
    default_values_description: "Non tutte le righe del file importato contengono dati per ogni colonna. Assegna valori predefiniti che FireCMS utilizzerà per le colonne mancanti.",
    property: "Proprietà",
    default_value: "Valore predefinito",
    autogenerate_id: "Genera automaticamente ID",
    id_column_description: "Imposta la colonna che verrà utilizzata come ID dell'entità",
    do_not_set_value: "Non impostare il valore",
    set_value_to_true: "Imposta il valore su Vero",
    set_value_to_false: "Imposta il valore su Falso",
    drag_and_drop_file: "Trascina e rilascia un file CSV, Excel o JSON qui, oppure fai clic per caricare",
    error_saving_data: "Errore durante il salvataggio dei dati",
    retry: "Riprova",
    saving_data: "Salvataggio dei dati in corso...",
    entities_saved: "entità salvate",
    do_not_close_tab: "Non chiudere questa scheda durante l'importazione dei dati",
    import: "Importa",
    import_data: "Importa dati",
    upload_file_description: "Carica il tuo file CSV, Excel o foglio di calcolo per importare i dati",
    back: "Indietro",
    next: "Avanti",
    save_data: "Salva dati",
    use_column_as_id: "Usa questa colonna come ID dell'entità",
    do_not_import_property: "Non importare questa proprietà",
    entities_will_be_overwritten: "Le entità esistenti con lo stesso ID verranno sovrascritte",
    data_imported_successfully: "Dati importati con successo",
    export: "Esporta",
    export_data: "Esporta dati",
    download_table_csv: "Scarica la tabella come file CSV",
    csv: "CSV",
    json: "JSON",
    dates_as_timestamps: "Date come timestamp",
    dates_as_strings: "Date come stringhe",
    flatten_arrays: "Appiattisci gli array",
    download: "Scarica",
    large_number_of_documents: "Questa collezione contiene un numero elevato di documenti ({{count}})",
    include_undefined_values: "Includi valori non definiti",
    submit: "Invia",

    no_filterable_properties: "Nessuna proprietà filtrabile disponibile",
    apply_filters: "Applica filtri",
    list: "Elenco",
    cards: "Schede",
    board: "Bacheca",
    initialize_kanban_order_desc: "Verranno assegnati valori di ordine sequenziali a tutti gli elementi che ne sono privi. Gli elementi manterranno l'ordine corrente all'interno di ciascuna colonna.",
    kanban_view_not_available: "Vista Kanban non disponibile",
    kanban_view_requires_enum: "La vista Kanban richiede una proprietà stringa con valori enumerati per raggruppare le entità nelle colonne. Aggiungi una proprietà enum allo schema della tua collezione per utilizzare questa vista.",
    no_enum_values_configured: "Nessun valore enumerativo configurato per \"{{property}}\"",
    items_need_backfill: "Alcuni elementi non hanno un ordine definito. Fai clic su 'Inizializza' per impostare l'ordine.",
    initialize: "Inizializza",
    confirm_multiple_delete: "Conferma eliminazione multipla",
    delete_entity_confirm_title: "Eliminare '{{entityName}}'?",

    /** Recently extracted strings for collection editor */
    /** AI Collection Generator Popover */
    generate_collection_with_ai: "Genera collezione con AI",
    modify_collection_with_ai: "Modifica collezione con AI",
    describe_collection_to_create: "Descrivi la collezione che vuoi creare.",
    describe_changes_to_make: "Descrivi le modifiche che vuoi apportare a questa collezione.",
    ai_placeholder_create: "es. Crea una collezione di prodotti con nome, prezzo, descrizione e categoria...",
    ai_placeholder_modify: "es. Aggiungi un campo immagine in miniatura con archiviazione, rendi il prezzo obbligatorio...",
    ai_assist: "Assistente AI",
    generating: "Generazione in corso...",

    this_is_subcollection_of: "Questa è una sottocollezione di",
    use_existing_paths_database: "Utilizza i percorsi esistenti nel database",
    describe_collection_ai: "Descrivi la collezione per generarla con l'IA",
    generate_with_ai: "Genera con IA",
    create_from_json_config: "Crea da configurazione JSON",
    paste_json_config: "Incolla la configurazione JSON",
    create_collection_from_file_formats: "Crea collezione da file (CSV, Excel, JSON)",
    select_template: "Seleziona un modello",
    products: "Prodotti",
    collection_products_subtitle: "Gestisci i tuoi prodotti con prezzi, inventario e immagini",
    collection_users_subtitle: "Gestisci gli utenti registrati con i loro profili e ruoli",
    blog_posts: "Articoli del blog",
    collection_blog_posts_subtitle: "Crea e gestisci gli articoli del tuo blog",
    pages: "Pagine",
    collection_pages_subtitle: "Gestisci le pagine statiche del tuo sito",
    continue_from_scratch: "Continua da zero",

    /** Admin views config */
    cms_users: "Utenti CMS",
    roles_menu: "Ruoli",
    project_settings: "Impostazioni del progetto",

    // ─── FireCMS Cloud Login ──────────────────────────────────────
    build_admin_panel_in_minutes: "Crea il tuo pannello di amministrazione Firebase in pochi minuti",
    go_live_instantly: "Online in un istante:",
    create_production_ready_back_offices: "Crea back-office pronti per la produzione",
    without_the_frontend_hassle: "senza complicazioni frontend.",
    automatic_setup: "Configurazione automatica",
    from_your_existing_firestore_data: "dai tuoi dati Firestore esistenti.",
    seamless_real_time_firebase_integration: "Integrazione Firebase in tempo reale senza interruzioni.",
    intuitive_spreadsheet_like_ui: "Interfaccia intuitiva simile a un foglio di calcolo",
    your_whole_team_can_use: "che tutto il tuo team può usare.",
    focus_on_your_app: "Concentrati sulla tua app,",
    not_the_admin_panel: "non sul pannello di amministrazione.",
    join_our_newsletter: "Iscriviti alla nostra newsletter. Niente spam, solo aggiornamenti importanti!",
    by_signing_in_you_agree_to_our: "Accedendo accetti i nostri",
    terms_and_conditions: "Termini e Condizioni",
    and_our: "e la nostra",
    privacy_policy: "Informativa sulla privacy",
    firecms_cloud_google_disclosure: "L'uso e il trasferimento ad altre app delle informazioni ricevute dalle API di Google da parte di FireCMS Cloud rispetterà la",
    google_api_services_user_data_policy: "Informativa sui dati utente dei servizi API di Google",
    including_the_limited_use_requirements: "inclusi i requisiti di utilizzo limitato.",
    email_password: "Email/password",
    sign_in_with_google: "Accedi con Google",

    // --- Auth error messages ---
    auth_user_not_found: "Utente non trovato",
    auth_wrong_password: "Password errata",
    auth_user_disabled: "Account disabilitato",
    auth_account_exists_with_different_credential: "Esiste già un account con questo indirizzo email ma con credenziali diverse",
    auth_email_already_in_use: "Questo indirizzo email è già in uso",
    auth_google_permissions_required: "Sono necessarie le autorizzazioni di Google",
    auth_invalid_email_password: "Email o password non valide",
    auth_enter_email_first: "Inserisci prima l'indirizzo email",
    auth_password_reset_sent: "Email di reimpostazione della password inviata",
    auth_sign_in_account: "Accedi al tuo account",
    auth_create_new_account: "Crea un nuovo account",
    auth_password: "Password",
    auth_reset_password: "Reimposta password",
    auth_new_user: "Nuovo utente",
    auth_have_account: "Hai già un account?",
    auth_sign_in: "Accedi",
    auth_sign_up: "Registrati",

    // --- SaaS Subscriptions ---
    subscriptions: "Abbonamenti",
    manage_your_subscriptions_in_stripe: "Gestisci i tuoi abbonamenti su Stripe",
    go_to_your_stripe_portal: "Vai al portale Stripe per visualizzare la cronologia di fatturazione. Da lì puoi anche gestire gli abbonamenti associati all'utente connesso.",
    your_pro_licenses: "Le tue licenze PRO",
    create_new_license: "Crea nuova licenza",
    create_subscriptions_in_this_section: "Crea abbonamenti in questa sezione solo per FireCMS PRO self-hosted. Se utilizzi FireCMS Cloud, puoi aggiornare il piano dalle impostazioni del progetto.",
    if_you_are_an_agency: "Se sei un'agenzia, sei libero di rivendere la tua licenza ai tuoi clienti.",
    if_you_have_any_questions: "Per domande o assistenza, contattaci all'indirizzo",
    you_have_not_created_any_pro_licenses: "Non hai ancora creato nessuna licenza FireCMS PRO",
    archive: "Archivia",
    licensed_projects_lowercase: "progetti con licenza",
    manage: "Gestisci",
    update_payment_method: "Aggiorna metodo di pagamento",
    your_firecms_cloud_projects: "I tuoi progetti FireCMS Cloud",
    status_active: "Attivo",
    status_trialing: "In prova",
    status_past_due: "Scaduto",
    status_canceled: "Annullato",
    status_unpaid: "Non pagato",
    status_incomplete: "Incompleto",
    status_incomplete_expired: "Incompleto scaduto",
    status_unknown: "Sconosciuto",

    plan_free: "Non sottoscritto",
    plan_cloud_plus: "Iscritto",
    plan_pro: "Pro",
    plan_unknown: "Sconosciuto",

    auto_setup_collections_button: "Configura le collezioni automaticamente",
    auto_setup_collections_title: "Configurazione automatica delle collezioni",
    auto_setup_collections_desc: "Configura le collezioni automaticamente in base ai dati Firestore esistenti. Lascia che FireCMS configuri il CMS perfetto per te.",
    this_can_take_a_minute: "Potrebbe richiedere qualche minuto",
    no_collections_found_to_setup: "Nessuna collezione trovata da configurare",
    collections_have_been_setup: "Le collezioni sono state configurate",
    error_setting_up_collections: "Errore durante la configurazione delle collezioni",
    add_your: "Aggiungi le tue",
    database_collections: "collezioni del database",
    to_firecms: "a FireCMS",
    no_unmapped_collections: "Nessuna collezione non mappata",
    query_and_update_with_datatalk: "Interroga e aggiorna i tuoi dati in linguaggio naturale con DATATALK",
    welcome_to_firecms: "Benvenuto in FireCMS Cloud",
    admin_panel_ready_bring_data: "Il tuo pannello è pronto. Inizia aggiungendo i tuoi dati.",
    admin_panel_ready_get_started: "Il tuo pannello è pronto. Ecco come iniziare.",
    auto_detect_collections: "Rileva automaticamente le collezioni",
    auto_detect_collections_desc: "FireCMS analizzerà i tuoi dati Firestore e configurerà automaticamente le collezioni per te",
    create_a_collection: "Crea una collezione",
    create_collection_desc: "Definisci manualmente la struttura della tua collezione",
    read_the_docs: "Leggi la documentazione",
    read_the_docs_desc: "Scopri come usare FireCMS al meglio",
    explore_docs: "Esplora la documentazione",
    want_to_customize_with_code: "Vuoi personalizzare con il codice? Esegui",
    to_scaffold_a_local_project: "per creare un progetto locale",

    // ─── Collection Editor — Validation ──────────────────────────
    validation: "Validazione",
    unique: "Unico",
    required_message: "Messaggio campo obbligatorio",
    required_tooltip: "Non potrai salvare questa entità se questo valore non è impostato",
    unique_tooltip: "Non possono esistere più entità con lo stesso valore",
    lowercase: "Minuscolo",
    uppercase: "Maiuscolo",
    trim: "Rimuovi spazi",
    exact_length: "Lunghezza esatta",
    min_length: "Lunghezza min.",
    max_length: "Lunghezza max.",
    matches_regex: "Corrisponde a regex",
    not_valid_regexp: "Espressione regolare non valida",
    regex_helper: "es. /^\\d+$/ solo per cifre",
    min_value: "Valore min.",
    max_value: "Valore max.",
    less_than: "Minore di",
    more_than: "Maggiore di",
    positive_value: "Valore positivo",
    negative_value: "Valore negativo",
    integer_value: "Valore intero",

    // ─── Collection Editor — Property Edit ───────────────────────
    invalid_regular_expression: "Espressione regolare non valida",
    must_specify_target_collection: "Devi specificare una collezione di destinazione per il campo",
    need_specify_repeat_field: "Devi specificare un campo di ripetizione",
    need_specify_block_properties: "Devi specificare le proprietà di questo blocco",
    incomplete_condition: "Condizione incompleta - seleziona un campo",
    field_name: "Nome del campo",

    // ─── Collection Editor — Display & Config ────────────────────
    kanban_column_property: "Proprietà colonna Kanban",
    select_a_property: "Seleziona una proprietà",
    kanban_property_not_found: "La proprietà \"{{property}}\" non esiste o non è una proprietà string con enum. Seleziona una proprietà valida o cancella la selezione.",
    no_enum_string_properties: "Nessuna proprietà string con enum trovata. Aggiungi una proprietà string con enumValues per usare la vista Kanban.",
    kanban_column_description: "Seleziona una proprietà string con valori enum per raggruppare le entità in colonne",
    create_property: "+ Crea proprietà \"{{property}}\"",
    order_property: "Proprietà di ordinamento",
    order_property_not_found: "La proprietà \"{{property}}\" non esiste o non è una proprietà numerica. Seleziona una proprietà valida o cancella la selezione.",
    no_number_properties: "Nessuna proprietà numerica trovata. Aggiungi una proprietà numerica per abilitare l'ordinamento.",
    order_property_description: "Seleziona una proprietà numerica per mantenere l'ordine degli elementi",
    display_settings: "Impostazioni di visualizzazione",
    default_row_size: "Dimensione riga predefinita",
    side_dialog_width: "Larghezza del dialogo laterale",
    side_dialog_width_description: "Definisci opzionalmente la larghezza (in pixel) del dialogo laterale delle entità. Il valore predefinito è 768px",
    inline_editing_enabled: "I dati possono essere modificati direttamente nella vista tabella",
    inline_editing_disabled: "I dati possono essere modificati solo nella vista modulo",
    inline_editing_description: "Consenti la modifica dei dati direttamente nella vista tabella, senza aprire la vista modulo.",
    include_json_view: "Includi vista JSON",
    no_json_view: "Non includere vista JSON",
    json_view_description: "Includi la rappresentazione JSON del documento.",
    not_found_suffix: "non trovato",

    // ─── Editor ─────────────────────────────────────────────────
    editor_text: "Testo",
    editor_text_description: "Inizia a digitare con testo semplice.",
    editor_heading_1: "Intestazione 1",
    editor_heading_1_description: "Intestazione di sezione grande.",
    editor_heading_2: "Intestazione 2",
    editor_heading_2_description: "Intestazione di sezione media.",
    editor_heading_3: "Intestazione 3",
    editor_heading_3_description: "Intestazione di sezione piccola.",
    editor_todo_list: "Lista di cose da fare",
    editor_todo_list_description: "Tieni traccia delle attività con una lista di cose da fare.",
    editor_bullet_list: "Elenco puntato",
    editor_bullet_list_description: "Crea un semplice elenco puntato.",
    editor_numbered_list: "Elenco numerato",
    editor_numbered_list_description: "Crea un elenco con numerazione.",
    editor_quote: "Citazione",
    editor_quote_description: "Cattura una citazione.",
    editor_code: "Codice",
    editor_code_description: "Cattura un frammento di codice.",
    editor_image: "Immagine",
    editor_image_description: "Carica un'immagine dal tuo computer.",
    editor_multiple: "Multiplo",
    editor_link: "Link",
    editor_save: "Salva",
    editor_cancel: "Annulla",
    editor_remove_link: "Rimuovi link",
    editor_paste_or_type_link: "Incolla o digita il link",
    editor_open_in_new_window: "Apri in una nuova finestra",
    editor_bold: "Grassetto",
    editor_italic: "Corsivo",
    editor_underline: "Sottolineato",
    editor_strikethrough: "Barrato",
    editor_autocomplete: "Completamento automatico",
    editor_autocomplete_description: "Aggiungi testo basato sul contesto.",

    // ─── Cloud Project Settings ──────────────────────────────────
    settings_subscription_plan: "Piano di abbonamento",
    settings_subscribed_to: "Sei attualmente abbonato a",
    settings_no_active_subscription: "Al momento non esiste un abbonamento attivo per questo progetto.",
    settings_trial_valid_until: "Il tuo periodo di prova è valido fino al {{date}}.",
    settings_features_intro: "Queste sono alcune delle funzionalità di cui stai già usufruendo con FireCMS Cloud",
    settings_feature_managed_service: "Servizio gestito sempre aggiornato",
    settings_feature_local_text_search: "Ricerca testuale locale",
    settings_feature_unlimited_users_roles: "Utenti e ruoli illimitati",
    settings_feature_theme_logo: "Personalizzazione del tema e del logo",
    settings_feature_custom_fields_views: "Campi modulo e viste personalizzate",
    settings_feature_secondary_databases: "Database secondari",
    settings_feature_ai_content: "Generazione di contenuti con IA di OpenAI e Google",
    settings_feature_unlimited_export: "Esportazione dati illimitata",
    settings_feature_appcheck: "AppCheck",
    settings_heading: "Impostazioni",
    settings_project_name: "Nome del progetto",
    settings_default_language: "Lingua predefinita",
    settings_default_language_caption: "Seleziona la lingua di base per questo progetto. Gli utenti possono modificare questa preferenza nelle impostazioni personali.",
    settings_enable_local_text_search: "Abilita la ricerca testuale locale",
    settings_local_text_search_caption: "Abilita la ricerca testuale locale per tutte le collezioni. Questo ti permetterà di cercare campi di testo nelle collezioni utilizzando la barra di ricerca di FireCMS. Tieni presente che questa funzionalità può comportare un numero maggiore di letture, poiché verranno indicizzati tutti i campi di testo delle tue collezioni.",
    settings_doc_history_all_collections: "Cronologia documenti abilitata per tutte le collezioni",
    settings_doc_history_caption: "Quando attivato, tutte le collezioni avranno la cronologia abilitata per impostazione predefinita. Puoi modificare questa impostazione per ogni singola collezione. La cronologia verrà salvata nella sottocollezione __history di ogni documento.",
    settings_theme: "Tema",
    settings_primary_color: "Colore primario",
    settings_secondary_color: "Colore secondario",
    settings_sample_theme_components: "Componenti di esempio del tema",
    settings_drag_drop_logo: "Trascina e rilascia il tuo logo qui",
    settings_create_subscription: "Crea un abbonamento",
    settings_stripe_disclaimer: "Verrai reindirizzato a Stripe per completare l'abbonamento. La fatturazione è mensile, basata sul numero massimo di utenti del mese. Puoi annullare in qualsiasi momento: hai già pagato il periodo di fatturazione corrente, quindi non verranno applicati costi aggiuntivi dopo l'annullamento.",
    settings_subscription_is: "L'abbonamento è",
    settings_next_payment_on: "Il prossimo pagamento è il {{date}}.",
    settings_seats_count: "Hai",
    settings_seat: "posto",
    settings_seats: "posti",
    settings_per_seat: "a {{price}}/posto/{{interval}}",
    settings_current_price: "Il prezzo attuale è",
    settings_per_user_usage: "per utente (basato sull'utilizzo).",
    settings_cancelled_active_until: "Questo abbonamento è stato annullato e rimarrà attivo fino al {{date}}.",
    settings_no_additional_charges: "Non verranno applicati costi aggiuntivi dopo l'annullamento.",
    settings_manage_subscription: "Gestisci abbonamento",
    settings_security_rules: "Regole di sicurezza",
    settings_security_rules_description: "FireCMS utilizza le regole di sicurezza di Firebase per limitare l'accesso ai dati. Quando si crea un nuovo utente tramite FireCMS, l'attributo personalizzato fireCMSUser viene aggiunto all'utente nel progetto client. Aggiungendo le seguenti regole di sicurezza al tuo progetto, ti assicuri che gli utenti FireCMS possano accedere ai dati tramite FireCMS.",
    settings_security_rules_add_domain: "Ricorda di aggiungere il dominio {{domain}} ai domini consentiti del tuo provider",
    settings_security_rules_caption: "Queste regole limitano l'accesso ai dati solo agli utenti FireCMS, ma non applicano i permessi a livello di database. I permessi vengono applicati nel frontend, il che funziona bene per la maggior parte dei progetti. Se hai bisogno di applicare i permessi a livello di database, puoi modificare queste regole di sicurezza. I ruoli assegnati a un utente vengono impostati come attributi personalizzati nel token di autenticazione Firebase, quindi puoi utilizzarli nelle tue regole di sicurezza.",
    settings_appcheck: "AppCheck",
    settings_appcheck_description: "Puoi abilitare AppCheck per proteggere i tuoi servizi Firebase da usi impropri. Consulta la documentazione Firebase per la configurazione. Quando hai un provider configurato, puoi abilitarlo qui. Dovrai fornire un segreto nelle impostazioni del tuo progetto Firebase e una chiave del sito nella configurazione di FireCMS.",
    settings_appcheck_add_domain: "Ricorda di aggiungere il dominio {{domain}} ai domini consentiti del tuo provider",
    settings_appcheck_enable: "Abilita AppCheck",
    settings_appcheck_site_key: "Chiave del sito",
    settings_appcheck_update: "Aggiorna AppCheck",
    settings_appcheck_refresh_note: "Potrebbe essere necessario aggiornare la pagina dopo il salvataggio per vedere le modifiche.",
    settings_appcheck_updated: "AppCheck aggiornato",
    settings_appcheck_error: "Errore nell'aggiornamento di AppCheck",

    // ─── Text Search Dialog ─────────────────────────────────────
    text_search_dialog_title: "Abilita ricerca testuale",
    text_search_local_not_recommended: "La ricerca testuale locale non è consigliata per collezioni di grandi dimensioni.",
    text_search_local_fetch_warning: "Tieni presente che abilitando la ricerca testuale locale sarà necessario scaricare tutti i documenti dalla collezione e memorizzarli nel browser. Questo può essere inefficiente per collezioni grandi e può comportare costi aggiuntivi.",
    text_search_external_suggestion: "Per collezioni più grandi, ti consigliamo di utilizzare un motore di ricerca esterno come Algolia o Elastic Search e di assegnare un delegato di ricerca alla tua configurazione.",
    text_search_local_description: "La ricerca testuale locale è il modo più semplice per abilitare la ricerca testuale nella tua collezione. Carica tutti i documenti della collezione nel browser ed esegue la ricerca localmente. È l'opzione consigliata per le collezioni piccole.",
    text_search_own_implementation: "Hai implementato il tuo controller di ricerca testuale. Puoi abilitare la ricerca testuale per la tua collezione.",
    text_search_enable_for_collection: "Abilita per questa collezione",
    text_search_enable_for_project: "Abilita per il progetto",
    text_search_enabled_snackbar: "Ricerca testuale locale abilitata"
};
